import { addDays, format, parse } from 'date-fns';

const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');
const today = format(new Date(), 'yyyy-MM-dd');

export const validateDate = (value?: string, isLegacySigSync?: boolean) => {
  if (!value) {
    return true;
  }

  const inputDate = parse(value, 'yyyy-MM-dd', new Date());

  if (isLegacySigSync) {
    const minDate = parse(today, 'yyyy-MM-dd', new Date());
    const isValid = inputDate >= minDate;
    return isValid;
  }

  const minDate = parse(tomorrow, 'yyyy-MM-dd', new Date());
  const isValid = inputDate >= minDate;
  return isValid;
};
